export default "__VITE_ASSET__k_cZXDfl__"